var map = {
	"./de/general8/slide2.svg": 619582,
	"./en/general8/slide2.svg": 639594,
	"./es/general8/slide2.svg": 601411,
	"./fr/general8/slide2.svg": 707691,
	"./nl/general8/slide2.svg": 347145,
	"./pt/general8/slide2.svg": 298119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 814194;